var exports = {
  "vK": "GiftInventoryBanner.module__banner___VHMwRU",
  "Qs": "GiftInventoryBanner.module__content___VHMwRU",
  "Kk": "GiftInventoryBanner.module__icon___VHMwRU",
  "FS": "GiftInventoryBanner.module__textContainer___VHMwRU",
  "DD": "GiftInventoryBanner.module__title___VHMwRU",
};

module.exports = exports;
